export const data = [
  {
    num: "95",
    type: "backend",
    role: "developers",
    abilityList: [
      "PHP7",
      "Python",
      "Jakarta EE",
      "Java SE",
      "Golang",
      "Docker",
    ],
    services: [
      "Development on the basis of frameworks",
      "Integration with highload services and solutions",
      "Work with DBMS SQL/NoSQL",
      "Architectural design and highload works",
      "Audit of a code and architecture",
      "Refactoring",
    ],
  },

  {
    num: "50",
    type: "frontend",
    role: "developers",
    abilityList: [
      "React",
      "Vue.js",
      "Angular",
      "NodeJS",
      "Typescript",
      "GraphQL",
    ],
    services: [
      "Cross-browser frontend",
      "Adaptive frontend",
      "Complex JS (Angular, React and other frameworks)",
      "Manual and automated frontend testing",
      "Audit of the code realized by other commands",
    ],
  },

  {
    num: "60",
    type: "IOS/Android",
    role: "developers",
    abilityList: ["Kotlin", "Swift", "Flutter", "SOLID", "Clean Architecture"],
    services: [
      "Native iOS / Android development",
      "Cross-platform development",
      "Middleware development",
      "Code and architecture audit",
      "Refactoring and revision",
      "Application support",
    ],
  },

  {
    num: "30",
    type: "QA",
    role: "engineers",
    abilityList: ["Selenium", "JMeter", "Postman", "SQL", "TestCaseLab"],
    services: [
      "Functional testing",
      "Regression testing",
      "Integration testing",
      "Load testing",
      "Smoke testing",
      "Stress testing",
      "Safety testing",
      "Usability testing",
      "Installation testing",
      "UI and API automated testing",
    ],
  },

  {
    num: "15",
    type: "Analysts",
    role: "",
    abilityList: ["SRS", "BPMN", "UML", "SQL / noSQL", "SOAP", "REST"],
    services: [
      "Collection, analysis and formalization of functional requirements",
      "Development and approval of technical specifications",
      "Setting tasks for developers",
      "Audit and control of compliance of the solution with the technical specifications",
      "Participation in the implementation and maintenance of the solution",
    ],
  },
];
